import { Close, Search } from '@mui/icons-material'
import { Box, IconButton, TextField } from '@mui/material'
import { useState } from 'react'
import { fuzzySearchList, FuzzySearchResult } from '@omnea-app/fe-legacy/utils/string/fuzzySearchList'
import { AvailableOrganisation } from '@omnea-app/login/loginFrontendClient'
import { normaliseString } from '@omnea-app/packages/universal/string-utils/removeDiacritics'

interface OrganisationSearchBoxProps {
  availableOrganisations: AvailableOrganisation[]
  onResultsChange: (newResults: FuzzySearchResult<AvailableOrganisation>[] | null) => void
  onSubmit: () => void
  onEscape: () => void
}

export const OrganisationSearchBox: React.FC<OrganisationSearchBoxProps> = ({
  availableOrganisations,
  onResultsChange,
  onSubmit,
  onEscape,
}) => {
  const [inputText, setInputText] = useState('')

  const clearSearch = () => {
    setInputText('')
    onResultsChange(null)
  }

  const handleSearchChange = (searchQuery: string) => {
    if (!searchQuery) {
      clearSearch()
      return
    }

    setInputText(searchQuery)
    const results = fuzzySearchList(availableOrganisations, searchQuery, (org) => org.name)
    onResultsChange(results)
  }

  return (
    <Box sx={{ width: '100%', padding: 2 }}>
      <TextField
        sx={{ width: '100%' }}
        id="outlined-basic"
        placeholder="Search"
        autoFocus
        value={inputText}
        onChange={(event) => handleSearchChange(event.target.value)}
        onFocus={(event) => event.stopPropagation()}
        onClick={(event) => event.stopPropagation()}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            event.preventDefault()
            event.stopPropagation()
            clearSearch()
            onEscape()
          }

          if (event.key === 'Enter') {
            event.preventDefault()
            event.stopPropagation()

            const isSearching = normaliseString(inputText).length > 0
            if (isSearching) {
              onSubmit()
            }
          }
        }}
        slotProps={{
          input: {
            endAdornment: inputText ? (
              // Negative margin to counteract the padding of the TextField and keep the icon aligned with the text
              <IconButton sx={{ mr: -1, my: -1 }} size="small" onClick={clearSearch} tabIndex={-1}>
                <Close sx={{ color: 'fg.muted' }} />
              </IconButton>
            ) : (
              <Search sx={{ color: 'fg.muted' }} />
            ),
          },
        }}
      />
    </Box>
  )
}
